import { Box, Button, Text } from "@pingux/astro";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "state/context/AuthContext";

const loginErrorMessages: Record<string, string> = {
  invalid_state: "We couldn't validate the sign-on request. Please try again.",
  auth_failed: "Sign on failed. Please try again.",
};

const Login = () => {
  const location = useLocation();
  const {
    state: { error, isAuthenticated, status },
  } = useAuthContext();

  const queryErrorCode =
    new URLSearchParams(location.search).get("error") || "";
  const errorMessage = error || loginErrorMessages[queryErrorCode] || null;

  const handleSignOn = () => {
    window.location.assign("/api/auth/login");
  };

  const handlePingSignOn = () => {
    window.location.assign("/api/auth/ping-flow/login");
  };

  if (isAuthenticated || status === "authenticated") {
    return <Navigate to="/" replace />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "10vh",
        padding: "2rem 0",
        marginTop: "2rem",
      }}
    >
      <Box sx={{ maxWidth: "420px", width: "100%", textAlign: "center" }}>
        <Text
          as="h1"
          sx={{
            fontSize: "1.75rem",
            fontWeight: "700",
            marginBottom: "0.75rem",
          }}
        >
          TAP Partner Vault
        </Text>
        <Text sx={{ color: "rgba(0, 0, 0, 0.65)", marginBottom: "1.5rem" }}>
          Sign on with PingOne to access the partner vault.
        </Text>
        {errorMessage && (
          <Box
            sx={{
              padding: "0.75rem 1rem",
              backgroundColor: "#fee2e2",
              borderRadius: "0.5rem",
              marginBottom: "1rem",
              borderLeft: "4px solid #dc2626",
            }}
          >
            <Text sx={{ color: "#991b1b", fontSize: "0.875rem" }}>
              {errorMessage}
            </Text>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.75rem",
          }}
        >
          <Button
            variant="primary"
            aria-label="TAP Team Sign On"
            onPress={handleSignOn}
            sx={{
              minWidth: "14.25rem",
              backgroundColor: "#1d4ed8",
              borderColor: "#1d4ed8",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "#1e40af",
                borderColor: "#1e40af",
              },
            }}
          >
            TAP Team Sign On
          </Button>
          <Button
            variant="primary"
            aria-label="Ping Sign On"
            onPress={handlePingSignOn}
            sx={{
              minWidth: "14.25rem",
              backgroundColor: "#0284c7",
              borderColor: "#0284c7",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "#0369a1",
                borderColor: "#0369a1",
              },
            }}
          >
            Ping Sign On
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
